<template>
	<div class="stamp-comment-list">
		<template v-if="!fullHeightTableStyle">
			<ManagingSection :columnCount="2">
				<ManagingBox title="닉네임" :horizontalMode="true">
					<input
						v-model="nickName"
						type="text"
						@keyup.enter="searching"
					/>
				</ManagingBox>
				<ManagingBox title="내용" :horizontalMode="true">
					<input
						v-model="content"
						type="text"
						@keyup.enter="searching"
					/>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button
					class="btn-main blue"
					v-text="'검색'"
					@click="searching"
				/>
				<button
					class="btn-main blue bordered"
					v-text="'초기화'"
					@click="initializing"
				/>
			</div>
		</template>
		<div
			:class="
				fullHeightTableStyle
					? 'stamp-comment-list__list-wrapper'
					: 'stamp-comment-list__list-scroller'
			"
		>
			<ManagingSection :isTable="true" :noPaddingTop="true">
				<template slot="infoSection">
					<b class="section__info__left" v-text="resultText" />
					<div class="section__info__right">
						<button
							class="section__info__items btn-excel"
							v-text="'CSV 다운'"
							@click="csvDown"
						/>
					</div>
				</template>
				<table class="table-main stamp-comment-list__list">
					<thead>
						<tr>
							<th
								v-for="item in thList"
								:key="item.id"
								:class="`stamp-comment-list__list-item--${item.id}`"
								v-text="item.text"
							/>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in list" :key="item.id">
							<td
								:class="`stamp-comment-list__list-item--${thList[0].id}`"
								v-text="item.created_at"
							/>
							<td
								:class="`stamp-comment-list__list-item--${thList[1].id}`"
								v-text="item.register_id"
							/>
							<td
								:class="`stamp-comment-list__list-item--${thList[2].id}`"
								v-text="item.nickName"
							/>
							<td
								:class="`stamp-comment-list__list-item--${thList[3].id}`"
							>
								<pre
									class="stamp-comment-list__content-item"
									v-text="item.content"
								/>
							</td>
							<td
								:class="`stamp-comment-list__list-item--${thList[4].id}`"
							>
								<input
									v-model="item.is_display"
									type="checkbox"
									class="stamp-comment-list__display-item"
									@change="toggleDisplay(item.id)"
								/>
							</td>
							<td
								:class="`stamp-comment-list__list-item--${thList[5].id}`"
							>
								<button
									class="btn red"
									v-text="'삭제'"
									@click="removeComment(item.id)"
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<PaginationBox
					slot="pagination"
					:totalItem="totalItem"
					:limit="limit"
					:offset="offset"
					:pageLengPerOne="10"
					@to="searching($event.offset)"
				/>
			</ManagingSection>
		</div>
	</div>
</template>
<script>
	import LibUtil from '@/lib/Util.js';
	import Util from '@/util.js';
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'StampCommentList',
		components: {
			ManagingSection,
			ManagingBox,
			PaginationBox,
		},
		data() {
			return {
				nickName: '',
				content: '',
				resultText: '',
				thList: [
					{ id: 'date', text: '등록일시' },
					{ id: 'id', text: '회원번호' },
					{ id: 'nickname', text: '닉네임' },
					{ id: 'content', text: '내용' },
					{ id: 'display', text: '노출상태' },
					{ id: 'delete', text: '삭제' },
				],
				limit: 50,
				offset: 0,
				list: [],
				totalItem: 0,
				lastParams: null,
				params: this.$route.params,
			};
		},
		computed: {
			...mapState({
				modalParams: state => state.modal.params,
			}),
			fullHeightTableStyle() {
				return this.params.idRegister;
			},
		},
		methods: {
			async getList(params) {
				const path = `/v3/api/stamp/${this.params.idStamp || this.modalParams.idStamp}/comment`;
				const {
					data: {
						stamp_comment,
						stamp_comment_total: [totalInfo],
					},
					config: { url },
				} = await this.$axiosAdmin2.get(path, { params });
				const list = stamp_comment.map(item => ({
					...item,
					created_at: LibUtil.format(item.created_at),
					isDpTxt: item.is_display ? '노출' : '미노출',
				}));
				return {
					list,
					totalInfo,
					url,
				};
			},
			async setList(offset = 0) {
				try {
					this.offset = typeof offset === 'number' ? offset : 0;
					const params = {
						offset: this.offset,
						limit: this.limit,
						nickName: this.nickName,
						content: this.content,
					};
					const { idRegister, date } = this.modalParams || {};
					if (idRegister) params.register_id = idRegister;
					if (date) params.date = date;
					const { list, totalInfo } = await this.getList(params);
					this.lastParams = params;
					this.resultText = `검색결과: 전체 ${totalInfo.total}건 / 노출 ${totalInfo.display_cnt}건 / 비노출 ${totalInfo.hide}건`;
					this.list = list;
					this.totalItem = totalInfo.total;
				} catch (err) {
					console.error(err);
					alert('목록을 불러오는데 실패했습니다.');
				}
			},
			searching(offset) {
				this.setList(offset);
			},
			initializing() {
				this.nickName = '';
				this.content = '';
				this.setList(0);
			},
			async csvDown() {
				try {
					const params = {
						...this.lastParams,
						offset: 0,
						limit: 99999,
					};
					const { list, url } = await this.getList(params);
					const rowsList = [
						list.map(item => [
							item.created_at,
							item.register_id,
							item.nickName,
							item.content,
							item.isDpTxt,
						]),
					];
					const colsList = [
						this.thList
							.slice(0, this.thList.length - 1)
							.map(item => item.text),
					];
					Util.getCsv(
						rowsList,
						undefined,
						colsList,
						`출석체크댓글_${Date.now()}`,
						url
					);
				} catch (err) {
					console.error(err);
					alert('CSV파일 다운 실패했습니다.');
				}
			},
			async toggleDisplay(id) {
				try {
					await this.$axiosAdmin2.put(
						`/v3/api/stamp/comment-display/${id}`
					);
				} catch (e) {
					console.error(e);
					alert('노출상태를 변경하는데 실패했습니다.');
					await this.$nextTick();
					const target = this.list.find(item => item.id === id);
					target.is_display = !target.is_display;
				}
			},
			async removeComment(id) {
				try {
					await this.$axiosAdmin2.delete(
						`/v3/api/stamp/comment/${id}`
					);
					this.setList(this.offset);
				} catch (e) {
					console.error(e);
					alert('삭제하는데 실패했습니다.');
				}
			},
		},
		created() {
			this.setList();
		},
	};
</script>
<style lang="scss" scoped>
	.stamp-comment-list {
		height: 100%;

		&__list-wrapper {
			overflow-y: scroll;
			height: 100%;
		}

		&__list-scroller {
			overflow-y: scroll;
			height: calc(100% - 200px);
		}

		&__list {
			table-layout: fixed;
		}

		&__list-item--date {
			width: 90px;
			padding: 0;
		}

		&__list-item--id {
			width: 90px;
			padding: 0;
		}

		&__list-item--nickname {
			width: 200px;
		}

		&__list-item--display {
			width: 70px;
			padding: 0;
		}

		&__list-item--delete {
			width: 70px;
			padding: 0;
		}

		&__content-item {
			text-align: left;
			white-space: pre-wrap;
			word-break: break-all;
			overflow: auto;
			font-size: inherit;
			padding: 0.5em;
			line-height: 120%;
		}

		&__display-item {
			cursor: pointer;
		}
	}
</style>
